module.exports = __webpack_public_path__ + "img/Panneaux_et_pancartes.0606a96.jpg";